<template lang="pug">
  //-  WTF??? It worked and was displaying playList.name
  //- leaving it as a riddle :)
  //- .container-dialog(v-if="!playListItem || !playListItem.id")
  //- seems we need a hack for [enter] button
  .container-dialog(v-if='playListItem' id="PlayListItemUnlik-container")
    button.invisible(v-if='!isSaving && !cannotUnlink()', style='opacity: .01', ref="submitButton", @keyup.enter="unlinkPlayItems()") {{  'invisible button '}}
    el-header.header(height='40px')
      span {{$t('You are removing ')}}
      span.emphasize {{ this.$store.state.Medium.playitems_selected_right.length }} {{ $t('playitems') }}
      span(v-if='playList.type === "PlayList"') {{$t(' from playlist ')}}
      span(v-if='playList.type === "PlayListLayout"') {{$t(' from layout ')}}
        span.emphasize(v-if='playListItem') {{playList.name}}
      hr.header
    el-row
      MediumInPlaylists(v-if='playListItem', :medium='playList')
    el-form(@submit="unlinkPlayItems()")
      el-button.float-right(
        id="PlayListItemUnlik-unlinkButton",
        type="success",
        size="mini",
        :disabled="isSaving || cannotUnlink()",
        @click="unlinkPlayItems()"
      )
        font-awesome-icon(icon="unlink")
        span &nbsp; {{$t(buttonSaveText())}}
    //- pre {{ this.$store.state.Medium.playitems_selected_right}}
    br
    br
</template>

<script>
import MediumIcon from './../Common/MediumIcon'
import MediumInPlaylists from './MediumInPlaylists'

export default {
  props: ['playListItem', 'playList'],
  components: {
    MediumIcon,
    MediumInPlaylists
  },
  created () {
    this.$nextTick(() => {
      this.$refs.submitButton.focus()
    })
  },
  data () {
    return {
      errors: [],
      isSaving: false
    }
  },
  watch: {
  },
  methods: {
    // For future use?
    cannotUnlink () {
      return false
    },
    buttonSaveText () {
      if (this.isSaving) return 'saving data...'
      return 'Unlink'
    },
    closePlayListItemUnlink () {
      this.$emit('close-playListItemUnlink')
    },
    async unlinkPlayItems (multi = false) {
      this.isSaving = true
      const pliIds = this.$store.state.Medium.playitems_selected_right.map(pli => pli.id)
      await this.$store.dispatch('Medium/removePlayItemFromPlaylist', pliIds)
      await this.$store.dispatch('Medium/getMedium', {
        data: this.playList.id,
        options: { populate: true }
      })
      this.$emit('close-playListItemUnlink')
      this.isSaving = false
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.header {
    color: $--color-text-secondary;
  .emphasize {
    color: $--color-text-regular;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/PlayListItemUnlink.vue